<div class="title-container">
    <span class="title-label">{{'myProfile.title' | translate}}</span>
</div>
<profile-category-selector class="title-container" 
    [selectedCategory]="selectedCategory"
    (categoryChange)="categoryChangeHandler($event)"
>
</profile-category-selector>

@switch (selectedCategory) {
    @case (PROFILE_CATEGORY.GENERAL) {
    <profile-general-view 
        [profileData]="profileData" 
        [requestTypes]="requestTypes"
        [readOnly]="readOnly"
    >
    </profile-general-view>
    }
    @case (PROFILE_CATEGORY.ADDRESSES) {
    <partner-address-list-view [addresses]="partnerAdresses">
    </partner-address-list-view>
    }
    @case (PROFILE_CATEGORY.BANK_ACCOUNTS) {
    <partner-bank-account-list-view [bankAccounts]="partnerBankAccounts">
    </partner-bank-account-list-view>
    }
}
